import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { HiLink } from "react-icons/hi";

import KeywordController from "../components/keyword";
import config from "../api/config";
import "../assets/css/advertising.css";
import { setToast } from "../redux/actions/ToastAction";
import { useDispatch } from "react-redux";
import { setUser } from "../redux/actions/AuthAction";

import IconTextField from "../components/InputWithIcon";
// {
//   "keywords": [
//     617
//   ],
//   "name": "string",
//   "url": "string"
// }

const isValidURL = (string) => {
  var res = string.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
  );
  return res !== null;
};

const AddUrlAd = () => {
  let { location } = useHistory();
  const data = location.data;
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(data ? data.name : "");
  const [url, setUrl] = useState(data ? data.url : "");
  const [allKeys, setAllKeys] = useState([]);
  const [selectedKeys, setSelectedkeys] = useState(data ? data.keywords : []);
  const [, setKeywordInput] = useState("");
  const [image, setImage] = useState(data ? data.iconUrl : "");
  const [imageBool, setImageBool] = useState(
    data ? (data.iconUrl ? true : false) : false
  );
  // navigate
  const navigate = useHistory();
  // dispatch
  const dispatch = useDispatch();

  // keywords
  const getAllKeys = () => {
    config
      .get(`/api/keyword/v1`)
      .then((data) => setAllKeys(data.data.objectKoinot.content));
  };
  useEffect(() => {
    getAllKeys();
  }, []);

  // ----search----
  const getFilteredItems = (query, items) => {
    setKeywordInput(query);

    setLoading(true);
    if (query === "") {
      config
        .get(`/api/keyword/v1?size=100`)
        .then((data) => {
          if (data.data.objectKoinot.content.length > 0) {
            setLoading(false);
            setAllKeys(data.data.objectKoinot.content);
          }
        })
        .catch((error) => {

        });
    } else {
      config.get(`/api/keyword/v1?search=${query}&size=100`).then((data) => {
        // let arr = data.data.objectKoinot.content.map((item, index) => item.key);
        setLoading(false);
        setAllKeys(data.data.objectKoinot.content);
      });
      // setAllKeys(items.filter((post) => post.key.includes(query)));
    }
  };
  // set keywords
  const keywordControl = (value) => {
    let arr = value.map((item, index) => item.key);
    setSelectedkeys(arr);
  };
  // submit new keywords
  const newKeyWordHandler = (e) => {
    setLoading(true);
    config
      .post(`/api/keyword/v1/setUser`, { word: e })
      .then((data) => {
        setLoading(false);
        getAllKeys();
      })
      .catch((e) => console.error(e?.message));
  };
  // image
  const iconController = (value) => {

    setImage(value);
    if (isValidURL(value)) {
      setImageBool(true);
    }
  };
  // submit
  const handleSubmit = async () => {
    let sb = {
      keywords: selectedKeys,
      name,
      url,
      iconUrl: imageBool ? image : "",
    };
    if (data) sb.id = data.id;
    try {
      const res = await config.post("/api/searchWebUrl/v1/saveOrEdit", sb);

      dispatch(
        setToast("true", "info", res.data?.message, res.data?.objectKoinot)
      );
      await config
        .get("/api/auth/v1/me")
        .then((data) => dispatch(setUser(data.data.objectKoinot)));
      navigate.push("/");
    } catch (err) {
      console.error(err?.message);
    }
  };
  return (
    <div className="">
      {data ? (
        <Button
          onClick={() => navigate.push(`/`)}
          variant="outlined"
          startIcon={<ArrowBackIosNewIcon />}
          style={{
            padding: "12px 22px",
            borderRadius: "40px",
            fontWeight: "bold",
          }}
        >
          Отменить и назад
        </Button>
      ) : null}
      {/* <h1>Добавте свой рекламу</h1> */}
      <div className="row">
        <div className="col-lg-6 col-md-12 ">
          <label htmlFor="name">Введите название рекламы</label> <br />
          <input
            id="name"
            type="text"
            placeholder="название"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <label htmlFor="url">Введите URL рекламы</label> <br />
          <input
            id="url"
            type="text"
            placeholder="URL"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
          <label htmlFor="tags-standard">Выберите ключевые слова</label>
          <KeywordController
            selectedkeys={selectedKeys}
            loading={loading}
            allkeys={allKeys}
            _callback={keywordControl}
            search={getFilteredItems}
            _input_callback={newKeyWordHandler}
          />
          <br />
          <label>Изображение для рекламы</label> <br />
          {/* <ImageUpload _callback={iconController} value={image} maxNumber={1} /> */}
          <IconTextField
            placeholder="Ссылка на изображение"
            iconStart={<HiLink />}
            fullWidth
            value={image}
            onChange={(e) => iconController(e.target.value)}
          />
          {imageBool ? (
            <div className="w-25 my-5">
              <img
                src={image}
                alt=""
                className="img-fluid"
                onError={() => setImageBool(false)}
              />
            </div>
          ) : (
            ""
          )}
          <Button
            variant="contained"
            style={{
              background: "var(--second-color)",
              padding: "12px 40px",
              borderRadius: "40px",
              marginTop: "20px",
              fontWeight: "bold",
            }}
            onClick={handleSubmit}
          >
            Сохранить
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddUrlAd;
